import { useState } from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  RadioGroup,
  FormControlLabel,
  Radio,
  // MenuItem,
} from "@mui/material";

import { getCategory } from "../utils/categories";
import { API_URL } from "../config/api";

type Props = {
  open: boolean;
  onClose: () => void;
  onAdded: (emailSent: boolean) => void;
};

export default function AddJudokaDialog({
  open,
  onClose,
  onAdded,
}: Props) {
  const [birthDate, setBirthDate] = useState("");
  // const [birthYear, setBirthYear] = useState(1900);
  const [licence, setLicence] = useState("");

  const [email, setEmail] = useState("");

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const [gender, setGender] = useState<"M" | "F">("M");

  const [nationality, setNationality] = useState("");

  const [clubNumber, setClubNumber] = useState("");
  const [clubName, setClubName] = useState("");

  const handleAdd = async () => {
  try {

    const registrationCode =
      localStorage.getItem("registrationCode");

    if (!registrationCode) {
      return;
    }

    const response = await fetch(
      `${API_URL}/registration/${registrationCode}/judokas`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          licence,
          firstName,
          lastName,
          gender,
          nationality,
          birthDate,
          category: getCategory(
            new Date(birthDate).getFullYear()
          ),
          clubNumber,
          clubName,
        }),
      }
    );

    if (!response.ok) {
      throw new Error("Erreur API");
    }

    const created = await response.json();

    onAdded(!!created.emailSent);

    onClose();

  } catch (err) {
    console.error(err);
  }
};

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>
        Ajouter un judoka
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid size={{ xs: 12, md: 6 }}>
            <TextField
              fullWidth
              label="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <TextField
              fullWidth
              label="Licence"
              value={licence}
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
                maxLength: 6,
              }}
              onChange={(e) =>
                setLicence(
                  e.target.value
                    .replace(/\D/g, "") // retire tout sauf les chiffres
                    .slice(0, 6)        // max 6 caractères
                )
              }
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <TextField
              fullWidth
              label="Nom"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <TextField
              fullWidth
              label="Prénom"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </Grid>

          <Grid size={{ xs: 12 }}>
            <RadioGroup row
              value={gender}
              onChange={(e) => setGender(e.target.value as "M" | "F")}
            >
              <FormControlLabel
                value="M"
                control={<Radio />}
                label="Garçon"
              />

              <FormControlLabel
                value="F"
                control={<Radio />}
                label="Fille"
              />
            </RadioGroup>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <TextField
              fullWidth
              label="Nationalité"
              value={nationality}
              onChange={(e) =>
                setNationality(e.target.value)
              }
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <TextField
              fullWidth
              type="date"
              label="Date de naissance"
              InputLabelProps={{
                shrink: true,
              }}
              value={birthDate}
              onChange={(e) =>
                setBirthDate(e.target.value)
              }
            />
          </Grid>

          <Grid size={{ xs: 12 }}>
            <TextField
              fullWidth
              disabled
              label="Catégorie"
              value={
                birthDate
                  ? getCategory(
                    new Date(birthDate).getFullYear()
                  )
                  : ""
              }
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <TextField
              fullWidth
              label="N° Club"
              value={clubNumber}
              onChange={(e) =>
                setClubNumber(e.target.value)
              }
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <TextField
              fullWidth
              label="Nom du club"
              value={clubName}
              onChange={(e) =>
                setClubName(e.target.value)
              }
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>
          Annuler
        </Button>

        <Button
          variant="contained"
          color="error"
          disabled={licence.length !== 6}
          onClick={handleAdd}
        >
          Ajouter
        </Button>
      </DialogActions>
    </Dialog >
  );
}